import Controller from "./report.controller";
import template from "./report.html";

const report = {
  template,
  controller: Controller,
};

export default report;



// WEBPACK FOOTER //
// ./src/pages/report/report.component.js